<template>
    <div ref="leafletMap" style="height: 500px; z-index: 1;"></div>
</template>
  
<script>
import L from 'leaflet';

export default {
    props: {
        plazasSeleccionadas: {
            type: Array,
            required: false
        },
        continuarConCompra: {
            type: Boolean,
            required: false
        },
        svgRendered: {
            type: SVGSVGElement,
            required: true
        },
        originalColor: {
            type: String,
            required: true
        }
    },
    mounted() {
        this.renderSvg();
    },
    watch: {
        clonedPlazasSeleccionadas(newValue, oldValue) {
            const plazaQuitada = oldValue.filter(({ id: newPlazaId }) => !newValue.some(({ id: oldPlazaId }) => newPlazaId === oldPlazaId));
            if (plazaQuitada) {
                plazaQuitada.forEach(plaza => {
                    const circle = document.querySelector(`[id^="butaca-${plaza.svg_id}-"]`);

                    if (circle) {
                        if(plaza.precios_taquilla.length > 0 && plaza.precios_online.length > 0){
                            circle.setAttribute('fill', plaza.originalColor ?? this.originalColor);
                        } else {
                            circle.setAttribute('fill', 'gray');
                        }
                        circle.setAttribute('seleccionado', 'false');
                    }    
                })
            }
        }
    },
    computed: {
        clonedPlazasSeleccionadas() {
            return this.plazasSeleccionadas ? [...this.plazasSeleccionadas] : null;
        }
    },
    methods: {
        renderSvg() {            
            const width = parseInt(this.svgRendered.getAttribute('width'));
            const height = parseInt(this.svgRendered.getAttribute('height'));

            const bounds = [[0, 0], [height, width]];
            
            const map = L.map(this.$refs.leafletMap, {
                wheelPxPerZoomLevel: 100,
                minZoom: -2,
                maxZoom: 2,
                crs: L.CRS.Simple,
                maxBounds: bounds,
                maxBoundsViscosity: 1,
                attributionControl: false,
                zoomSnap: 0.25,
                preferCanvas: true
            });            

            map.invalidateSize();

            map.on('movestart', () => {
                this.$emit('isPanning', true);
            });

            map.on('moveend', () => {
                this.$emit('isPanning', false)
            })

            L.svgOverlay(this.svgRendered, bounds, { 
                interactive: true 
            }).addTo(map);
            
            map.setView([height/2, width/2], -1.6)
        }
    },
};
</script>